import { SoundPromptCommand } from "appworks/commands/sound/sound-prompt-command";
import { Components } from "appworks/components/components";
import { gameLoop } from "appworks/core/game-loop";
import { gameState } from "appworks/model/game-state";
import { AbstractBetService } from "appworks/services/bet/abstract-bet-service";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { LocalStorageService } from "appworks/services/storage/local-storage-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { gameiom } from "gameiom/gameiom";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { AlertComponent } from "slotworks/components/alert/alert-component";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { InitState } from "slotworks/state-machine/standard/states/init-state";

export class AgsInitState extends InitState {
    public onEnter(): void {
        gameiom.setupServices();
        super.onEnter();

        Components.get(AlertComponent).onFatal.add(() => {
            gameLoop.setPaused("fatalError", true);
        });
    }
    public complete(): void {
        this.initWrapper();

        super.complete();
    }

    protected initWrapper() {
        const gameplay = gameState.getCurrentGame();
        gameWrapper.balancesUpdate(
            gameplay.realBalance,
            gameplay.freeBalance
        );
        gameWrapper.stakeUpdate(Services.get(AbstractBetService).getTotalStake());
        if (gameplay.getCurrentRecord()) {
            gameWrapper.winningsUpdate(gameplay.getCurrentRecord().cashWon);
        } else {
            gameWrapper.winningsUpdate(0);
        }

        gameWrapper.gameLoadingEnded();
    }

    protected enableSound(): Contract<boolean> {
        this.setupGameComponents();

        const haveShownPrompt = Services.get(LocalStorageService).getBoolean("SoundPromptShown");
        let soundPromptContract: Contract<any>;

        if (!haveShownPrompt && !gameiomModel.hideEnableSoundsPrompt) {
            soundPromptContract = new Sequence([
                () => SoundPromptCommand("sound_prompt", true),
                () => Contract.wrap(() => Services.get(LocalStorageService).set("SoundPromptShown", true))
            ]);
        } else {
            soundPromptContract = Contract.empty();
        }

        return new Sequence([
            () => soundPromptContract,
            () => Contract.wrap(() => Services.get(SoundService).customEvent("ags_start_game"))
        ]);
    }

    protected setupGameComponents(): void {
        const spinRecord = gameState.getCurrentGame().getRootRecord() as SpinRecord;

        if (Components.get(MatrixComponent) && spinRecord.grid) {
            Components.get(MatrixComponent).jumpToGrid(spinRecord.grid);
        }
    }
}
